// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"f0f50429","134":"d3256804","249":"3bf235e6","271":"def06f77","345":"3bf235e6","374":"ad2cb427","467":"56bb8637","507":"98c23d53","610":"76295b91","765":"7c671fa7","778":"ff76ee50","836":"73e5cc86","917":"810dd623"}[chunkId] + ".chunk.css";
};